import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["data"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable camelcase */
import { GET_COUPON_DETAILS_BY_COUPON_CODE } from '../gql/queries';
import { useQuery } from '@apollo/client';
import { APOLLO_COMMERCE_CONTEXT } from '../gql/constants';
export var useCouponCodeTerms = function useCouponCodeTerms(variables, options) {
  var _data$subscriptionCou, _data$subscriptionCou2;
  var skip = !variables.couponCode || (options === null || options === void 0 ? void 0 : options.skip);
  var _useQuery = useQuery(GET_COUPON_DETAILS_BY_COUPON_CODE, _objectSpread(_objectSpread({}, options), {}, {
      skip: skip,
      variables: variables,
      context: _defineProperty({}, APOLLO_COMMERCE_CONTEXT, true)
    })),
    data = _useQuery.data,
    queryResultRest = _objectWithoutProperties(_useQuery, _excluded);
  return _objectSpread(_objectSpread({}, queryResultRest), {}, {
    data: data,
    couponDetailsCode: (_data$subscriptionCou = data === null || data === void 0 || (_data$subscriptionCou2 = data.subscriptionCoupon) === null || _data$subscriptionCou2 === void 0 ? void 0 : _data$subscriptionCou2.couponCode) !== null && _data$subscriptionCou !== void 0 ? _data$subscriptionCou : null
  });
};
export default useCouponCodeTerms;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/hooks/useCouponCodeTerms.js
// module id = 3515
// module chunks = 11